var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.props.attributes.value),expression:"props.attributes.value"}]})}
var staticRenderFns = []

export { render, staticRenderFns }